const { CONSTANTS } = require('../../config')
const { size } = require('../size')
const { getAgeFromSsn, removeSsnYearPrefix } = require('../ssn')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * Sets any dynamic content and returns an object with the matched content.
 * @param {string} country
 * @param {object} dynamicContent
 * @param {object} form
 * @param {string} currentGroup
 * @returns {object|null}
 */
function setDynamicContent ({ country, dynamicContent, form, currentGroup } = {}) {
  if (!size(dynamicContent) || !size(form)) return

  const output = {
    label: null,
    error: null,
    tooltipTitle: null,
    tooltipText: null
  }

  let matchedItem = null

  for (const i in dynamicContent) {
    const item = dynamicContent[i]

    let group = item?.group
    const field = item?.field
    const compareValue = item?.value

    if (group === 'applicant' && currentGroup === 'coApplicant') group = 'coApplicant'
    const fieldValue = form?.[group]?.[field]?.value

    // Some specific dynamicContent handling for ssn
    if (field === 'ssn') {
      const age = getAgeFromSsn({ country, value: fieldValue })
      const otherApplicant = group === 'coApplicant' ? 'applicant' : 'coApplicant'
      const hasCoApplicant = form?.global?.hasCoApplicant?.value

      if (
        compareValue === 'sameAsOtherApplicant' &&
        form?.[group]?.[field]?.value &&
        form?.[otherApplicant]?.[field]?.value &&
        hasCoApplicant &&
        removeSsnYearPrefix({ country, value: form?.[group]?.[field]?.value }) === removeSsnYearPrefix({ country, value: form?.[otherApplicant]?.[field]?.value })
      ) {
        matchedItem = item
        break
      } else if (
        compareValue === 'ageTooOld' &&
        age > CONSTANTS[country?.toUpperCase()]?.AGE?.MAX
      ) {
        matchedItem = item
        break
      } else if (
        compareValue === 'ageTooYoung' &&
        age < CONSTANTS[country?.toUpperCase()]?.AGE?.MIN
      ) {
        matchedItem = item
        break
      }
    }

    if (fieldValue === compareValue) {
      matchedItem = item
      break
    }
  }

  if (matchedItem?.label) output.label = matchedItem?.label
  if (matchedItem?.error) output.error = matchedItem?.error
  if (matchedItem?.tooltipTitle) output.tooltipTitle = matchedItem?.tooltipTitle
  if (matchedItem?.tooltipText) output.tooltipText = matchedItem?.tooltipText

  return output
}

module.exports = { setDynamicContent }
